import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import Dialog from './dialog';
import { DefaultButton, RedButton } from './buttons';

var CancelDialog = function (_PureComponent) {
  _inherits(CancelDialog, _PureComponent);

  function CancelDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CancelDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CancelDialog.__proto__ || _Object$getPrototypeOf(CancelDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      var onConfirm = _this.props.onConfirm;
      e.preventDefault();
      onConfirm();
    }, _this.handleEsc = function (e) {
      var onConfirm = _this.props.onConfirm; // Esc key

      if (e.keyCode === 27) {
        onConfirm();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CancelDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          innerRef = _props.innerRef,
          onBack = _props.onBack,
          title = _props.title,
          content = _props.content;
      var buttons = React.createElement('div', null, React.createElement(DefaultButton, {
        type: 'button',
        onClick: onBack
      }, 'Go Back'), React.createElement(RedButton, {
        type: 'submit'
      }, 'Yes, Cancel'));
      return React.createElement(Dialog, {
        innerRef: innerRef,
        title: title,
        buttons: buttons,
        onSubmit: this.handleSubmit,
        width: '500px'
      }, content);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('keydown', this.handleEsc, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('keydown', this.handleEsc, false);
    }
  }]);

  return CancelDialog;
}(PureComponent);

CancelDialog.displayName = 'CancelDialog';
export default CancelDialog;